import { Component, OnInit } from '@angular/core';


import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormsModule } from '@angular/forms';
import { first } from 'rxjs/operators';

//import { UserService } from '../../services/user.service';
import { CommonDataService } from '../../services/common-data.service';
import { CommerceDataService } from '../../services/commerce-data.service';
import { environment } from '../../../environments/environment';

declare var $:any;
declare var iziToast:any;


@Component({
  selector: 'app-contacts-page',
  templateUrl: './contacts-page.component.html',
  styleUrls: ['./contacts-page.component.css']
})
export class ContactsPageComponent implements OnInit {

  pageName = "Contact Us";

  modelForm: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private _data: CommonDataService,
    private _ecomm: CommerceDataService
  ) { }

  ngOnInit() {

      $('#initialise-page').trigger('click');
      this.prepForm()
      
  }

  prepForm() {
    this.modelForm = this.formBuilder.group({
      name: ['', Validators.required], 
      email: ['', Validators.required], 
      subject: ['', Validators.required], 
      category: ['', Validators.required], 
      message: ['', Validators.required], 
    });
  }

  submit() {

    $('#buttonText').text('Please Wait...');
    $('#loader').show();
    
    if (!this.modelForm.invalid) {
      this.sendEmailQuery(); // run combine function
    }

    else {

      let h = {
        class: "iziToast-warning",
        title:  "Invalid Form:",
        message:  "Complete all fields and submit again!",
        animateInside: !1,
        position: "topRight",
        progressBar: !1,
        icon: "icon-bell",
        timeout: 3200,
        transitionIn: "fadeInLeft",
        transitionOut: "fadeOut",
        transitionInMobile: "fadeIn",
        transitionOutMobile: "fadeOut",
      };
      iziToast.show(h);

      $('#buttonText').text('Submit Message');
      $('#loader').hide();
    }

  }

  sendEmailQuery() {

    let modelObject1 = new FormData();
    modelObject1.append('modelName', 'AdminEmail');

    modelObject1.append('emailDetails-fromName', this.modelForm.controls['name'].value);
    modelObject1.append('emailDetails-from', this.modelForm.controls['email'].value);
    modelObject1.append('emailDetails-subject', this.modelForm.controls['subject'].value);
    modelObject1.append('emailDetails-category', this.modelForm.controls['category'].value);
    modelObject1.append('emailDetails-message', this.modelForm.controls['message'].value);

    this._data.dynamicFormPost(modelObject1, 'submit-query-message') 
    // this._data.updateModelData(modelObject1)
       .pipe(first())
       .subscribe(
         data => {
           console.log(data);

            // alert(data['quote']['methodId']['fee']);
         },
         error => {
            $('#loader').hide();
         },

         () => {

            let h = {
              class: "iziToast-success",
              title:  "Success:",
              message:  "Your query has been submitted and will attended to shortly!",
              animateInside: !1,
              position: "topRight",
              progressBar: !1,
              icon: "icon-bell",
              timeout: 3200,
              transitionIn: "fadeInLeft",
              transitionOut: "fadeOut",
              transitionInMobile: "fadeIn",
              transitionOutMobile: "fadeOut",
            };
            iziToast.show(h);

            this.prepForm()
            $('#loader').hide();
         }
     );
  }

}
